import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ConnectionService} from './connection.service';
import {AppConfig} from '../app.config';
import {Observable} from 'rxjs/Observable';
import {RequisitionLine} from '../entities/RequisitionLine';
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class RequisitionLineService {

  private params: string;
  private feedback: string;
  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config : AppConfig,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/RequisitionLine/';
  }

  Create(requisitionLine: RequisitionLine): Observable<any> {
    this.params = JSON.stringify(requisitionLine);
    return this.http
      .post(this.apiUrl + 'Create', this.params, this.getHeaders());
  }

  CreateMultiple(requisitionLines: RequisitionLine[]): Observable<any> {
    this.params = JSON.stringify(requisitionLines);
    return this.http
      .post(this.apiUrl + 'CreateMultiple', this.params, this.getHeaders());
  }

  Get(): Observable<RequisitionLine[]> {
    return this.requestInterceptor
      .get(this.apiUrl, this.getHeaders())
      .map(response => response.json() as RequisitionLine[]);
  }

  GetAllForTask(taskGuid: string): Observable<RequisitionLine[]> {
    return this.requestInterceptor
      .get(this.apiUrl + 'GetAllForTask/' + taskGuid, this.getHeaders())
      .map(response => response.json() as RequisitionLine[]);
  }

  Put(item: RequisitionLine): Observable<any> {
    this.params = JSON.stringify(item);
    return this.http
      .put(this.apiUrl + 'Update/', this.params, this.getHeaders());
  }

  Delete(no: string): Observable<any> {
    return this.http
      .delete(this.apiUrl + 'Delete/' + no, this.getHeaders());
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/requisition-line.service.ts